// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const inteleon_gmax: PokeData = {
  "id": 10211,
  "name": "inteleon-gmax",
  "height": 400,
  "weight": 10000,
  "base_experience": 265,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [],
  "moves": [
    "aqua-tail",
    "aqua-jet",
    "aqua-cutter",
    "brine",
    "hydro-pump",
    "bubble-beam",
    "water-spout",
    "life-dew",
    "bubble",
    "whirlpool"
  ],
  "evolution_chain": {
    "id": 432,
    "item": null,
    "species": [
      {
        "name": "sobble",
        "order": 816,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "drizzile",
        "order": 817,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 816,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "inteleon",
        "order": 818,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 817,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 86,
    "speed": 154,
    "ability_power": 160
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": true,
  "regional_variant": null
} as const;
